import axios from "../utils/axios.wrapper";

export const getProducts = async () => {
  const { data} = await axios.get("/product");
  return data;
};

export const getActiveProducts = async () => {
  const { data } = await axios.get("/product/active");
  return data.items || data;
};

export const getForSaleProducts = async () => {
  const { data } = await axios.get("/product/for-sale");
  return data.items || data;
};

export const getInactiveProducts = async () => {
  const { data } = await axios.get("/product/inactive");
  return data.items || data;
};

export const getProductById = async (id) => {
  const { data } = await axios.get(`/product/${id}`);
  return data;
};

export const getLightProducts = async () => {
  const { data } = await axios.get("/product/light");
  return data; // Returns a flat array of ProductLightDto
};

export const getProductByName = async (name) => {
  const { data } = await axios.get(`/product/name/${name}`);
  return data;
};

export const getProductByCode = async (code) => {
  const { data } = await axios.get(`/product/code/${code}`);
  return data;
};

export const getProductsByCategory = async (categoryId) => {
  const { data } = await axios.get(`/product/category/${categoryId}`);
  return data;
};

export const getProductsByBrand = async (brandId) => {
  const { data } = await axios.get(`/product/brand/${brandId}`);
  return data;
};

export const getProductsBySupplier = async (supplierId) => {
  const { data } = await axios.get(`/product/supplier/${supplierId}`);
  return data;
};

export const searchProducts = async (query) => {
  const { data } = await axios.get(`/product/search?q=${encodeURIComponent(query)}`);
  return data;
};

export const createProduct = async (product) => {
  const { data } = await axios.post("/product/create", product);
  return data;
};

export const updateProduct = async (id, product) => {
  const { data } = await axios.put(`/product/${id}`, product);
  return data;
};

export const deleteProduct = async (id) => {
  const { data } = await axios.delete(`/product/${id}`);
  return data;
};

export const hardDeleteProduct = async (id) => {
  const { data } = await axios.delete(`/product/hard/${id}`);
  return data;
};

export const importProducts = async (file) => {
  const formData = new FormData();
  formData.append('File', file);
  const { data } = await axios.post("/product/import", formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
};

export const downloadProductTemplate = async () => {
  const response = await axios.get("/product/download-template", {
    responseType: 'blob',
  });
  return response;
};

export const getPaginatedProducts = async (filters = {}) => {
  const { data } = await axios.post("/product/paginate", filters);
  return data; // Returns {items: [], totalCount: number}
};

export const restoreProduct = async (id) => {
  const { data } = await axios.post(`/product/restore/${id}`);
  return data;
};

export const pushSalePrices = async () => {
  const { data } = await axios.post("/externalshopsync/push-sale-prices");
  return data;
};

export const getSummaryProducts = async () => {
  const { data } = await axios.get("/product/summary");
  return data;
};
export const getSummaryComposedProducts = async () => {
  const { data } = await axios.get("/product/summary/composed");
  return data;
};

export const productService = {
  getProducts,
  getActiveProducts,
  getForSaleProducts,
  getInactiveProducts,
  getProductById,
  getProductByName,
  getProductByCode,
  getProductsByCategory,
  getProductsByBrand,
  getProductsBySupplier,
  searchProducts,
  createProduct,
  updateProduct,
  deleteProduct,
  hardDeleteProduct,
  importProducts,
  downloadProductTemplate,
  getPaginatedProducts,
  restoreProduct,
  pushSalePrices,
  getLightProducts,
  getSummaryProducts,
  getSummaryComposedProducts,
};